import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, NgControlStatus, Validators } from "@angular/forms";
import { AcuseRecibo } from "src/app/models/Dte/AcuseRecibo";
import { AcuseReciboMasivo } from "src/app/models/Dte/AcuseReciboMasivo";
import { DteRecibido } from "src/app/models/Dte/DteRecibido";
import { TipoAcuseRecibo } from "src/app/models/Dte/TipoAcuseRecibo";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { PermissionService } from "src/app/services/permission.service";
import { TokenStorageService } from "src/app/services/token-storage.service";

@Component({
   selector: "app-acuse-recibo-multiple",
   templateUrl: "./acuse-recibo-multiple.component.html",
   styleUrls: ["./acuse-recibo-multiple.component.scss"],
})
export class AcuseReciboMultipleComponent implements OnInit {
   @Input() public itemsReception: DteRecibido[] = [];
   @Input() private acceptMode: boolean = false;
   @Output() private sendCloseRequestEmitter: EventEmitter<any> = new EventEmitter<any>();
   @Output() private sendMassiveRequestEmitter: EventEmitter<AcuseReciboMasivo> = new EventEmitter<AcuseReciboMasivo>();
   listaAcuseSuperForm: FormGroup;
   arrayRespuestasAcuse: AcuseRecibo[];
   public motivos = [
      {
         name: "Aceptado",
         disabled: !this.permissions.getPermission("50-10-26-10").asignado,
      },
      {
         name: "Aceptado con Reparos",
         disabled: !this.permissions.getPermission("50-10-26-12").asignado,
      },
      {
         name: "Rechazado",
         disabled: !this.permissions.getPermission("50-10-26-14").asignado,
      },
   ];
   public AcuseReciboTypes;
   public AcuseReciboRejectedTypes: any[] = [];
   private currentEmisorId = this.tokenStorage.getCompany();

   constructor(private formBuilder: FormBuilder, public permissions: PermissionService, private localStorage: LocalStorageService, private tokenStorage: TokenStorageService) {
      this.AcuseReciboTypes = JSON.parse(this.localStorage.getTipoAcuseRecibo()) as TipoAcuseRecibo[];
      this.AcuseReciboTypes.forEach((element) => {
         if (element.codigo != 0 && element.codigo != 2) {
            this.AcuseReciboRejectedTypes.push(element);
         }
      });
   }

   ngOnInit(): void {
      if (this.acceptMode) {
         this.motivos.pop();
      } else {
         //this.motivos = [this.motivos.pop()];
      }
      this.setAcuseGrupalSuperGroup();
   }

   setAcuseGrupalSuperGroup() {
      this.listaAcuseSuperForm = this.formBuilder.group({
         lista: this.formBuilder.array([]),
      });
      this.itemsReception.forEach((doc) => {
         (this.listaAcuseSuperForm.controls.lista as FormArray).push(this.setAcuseFormGroup(doc.dteId));
      });
   }
   setAcuseFormGroup(id): FormGroup {
      let group = this.formBuilder.group({
         id: [id, Validators.required],
         response: [this.acceptMode ? this.motivos[0] : this.motivos[2], Validators.required],
         rejectionType: [this.AcuseReciboRejectedTypes[0], this.acceptMode ? [] : [Validators.required]],
         description: [, Validators.required],
      });
      if (!this.acceptMode) {
         group.controls.response.disable();
      }
      return group;
   }

   getListFormArray(): FormArray {
      return this.listaAcuseSuperForm.controls.lista as FormArray;
   }

   rechazoRelatedValue(motivo: any) {
      //return motivo == this.motivos[2];
      return !this.acceptMode;
   }
   getGroupFormAcuseArray(index: number): FormGroup {
      return (this.listaAcuseSuperForm.controls.lista as FormArray).controls[index] as FormGroup;
   }

   sendCloseRequest() {
      this.sendCloseRequestEmitter.emit();
   }

   onSubmit() {
      let arrayAcuses = [];
      if (!this.listaAcuseSuperForm.valid) {
         return;
      }

      this.getListFormArray().controls.forEach((acuseForm) => {
         arrayAcuses.push(this.createAcuseRequestFromFormGroup(acuseForm as FormGroup));
      });
      let massiveRequest = new AcuseReciboMasivo();
      massiveRequest.emisorId = this.currentEmisorId;
      massiveRequest.replySendModels = arrayAcuses;
      this.sendMassiveRequestEmitter.emit(massiveRequest);
   }

   createAcuseRequestFromFormGroup(acuseFormGroup: FormGroup): AcuseRecibo {
      let recibo: AcuseRecibo = new AcuseRecibo();
      recibo.emisorId = this.currentEmisorId;
      recibo.id = acuseFormGroup.controls.id.value;
      if (acuseFormGroup.controls.response.value == this.motivos[0]) recibo.response = 3;
      if (acuseFormGroup.controls.response.value == this.motivos[1]) recibo.response = 4;
      if (acuseFormGroup.controls.response.value == this.motivos[2]) recibo.response = 5;
      recibo.rejectionType = acuseFormGroup.controls.rejectionType && !this.acceptMode ? acuseFormGroup.controls.rejectionType.value.codigo : null;
      recibo.description = acuseFormGroup.controls.description.value;
      return recibo;
   }
}
